import "./App.css";
import React from "react";
import { useEffect, useState } from "react";
import { BrowserRouter, Router, Route, Routes, Link } from "react-router-dom";
import Home from "./Pages/Home/HomeScreen";
import Gallery from "./Pages/Gallery/GalleryScreen";
import NoPage from "./Pages/NoPage";
import ReactGA from "react-ga";
import useMediaQuery from "./hooks/useMediaQuery";

const MEASUREMENT_ID = "G-3PB700W4DQ";
ReactGA.initialize(MEASUREMENT_ID);

function App() {
  return (
    <div className="app">
      <BrowserRouter>
        <Routes>
          <Route index element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="*" element={<NoPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
